var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMode === 'top')?_c('span',{staticClass:"info-box-icon",class:_vm.getColor},[_c('i',{staticClass:"fa",class:_vm.getIcon})]):_c('i',{staticClass:"fa fa-fw",class:[_vm.getIcon, _vm.getColor]})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108705d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/InfoIcon.vue
// module id = null
// module chunks = 